import type { User } from '@/core/domain';
import type { GetUserByIdOptions, UserRepository } from '../repositories/user-repository';

export class GetUserByIdUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(id: string, options?: GetUserByIdOptions): Promise<User | null> {
    return this.repository.getById(id, options);
  }
}
